<div #editorContainer class="editor-container">
  @if (initial()) {
    <div class="editor-wrapper">
      <editor #editor [id]="id" [init]="editorInit" class="frame-editor readonly-frame-editor" [(ngModel)]="html" (onInit)="onInit.emit()">
      </editor>
    </div>
  }
  @if (!visibleEditor() || !initial()) {
    <ng-container *ngTemplateOutlet="loadingContent"></ng-container>
  }
</div>

<ng-template #loadingContent>
  <div class="hidden-frame-editor">
    <result-ghost [showAvatar]="false" [ghostingLine]="3"></result-ghost>
  </div>
</ng-template>
